import { Engine } from "../../Engines/engine";
/** @hidden */
export var _forceTransformFeedbackToBundle = true;
Engine.prototype.createTransformFeedback = function () {
    return this._gl.createTransformFeedback();
};
Engine.prototype.deleteTransformFeedback = function (value) {
    this._gl.deleteTransformFeedback(value);
};
Engine.prototype.bindTransformFeedback = function (value) {
    this._gl.bindTransformFeedback(this._gl.TRANSFORM_FEEDBACK, value);
};
Engine.prototype.beginTransformFeedback = function (usePoints) {
    if (usePoints === void 0) { usePoints = true; }
    this._gl.beginTransformFeedback(usePoints ? this._gl.POINTS : this._gl.TRIANGLES);
};
Engine.prototype.endTransformFeedback = function () {
    this._gl.endTransformFeedback();
};
Engine.prototype.setTranformFeedbackVaryings = function (program, value) {
    this._gl.transformFeedbackVaryings(program, value, this._gl.INTERLEAVED_ATTRIBS);
};
Engine.prototype.bindTransformFeedbackBuffer = function (value) {
    this._gl.bindBufferBase(this._gl.TRANSFORM_FEEDBACK_BUFFER, 0, value ? value.underlyingResource : null);
};
//# sourceMappingURL=engine.transformFeedback.js.map